module.exports = __webpack_public_path__ + "img/cascata_01.19966562.jpg";